import React, { useEffect, useState } from 'react';
import { getLoginEvents } from '../../services/api';
import Pager from '../ui/Pager';
import Modal from '../ui/Modal';
import { formatDateTime, badge, td, th, theadRow, muted, label, input } from './userStyles';

const PAGE_SIZE = 20;

const FAILURES = {
  BAD_PASSWORD: 'Mot de passe incorrect',
  BLOCKED: 'Compte bloqué',
  UNKNOWN_USER: 'Utilisateur inconnu',
  BAD_MFA_CODE: 'Code MFA incorrect',
  MFA_LOCKED: 'Codes MFA bloqués',
  IP_NOT_ALLOWED: 'IP non autorisée',
};

// Second facteur d'une connexion réussie (DO-207)
const SECOND_FACTORS = {
  TOTP: 'code MFA',
  TRUSTED_BROWSER: 'navigateur de confiance',
};

/**
 * Journal de connexion paginé (DO-208) : celui d'un utilisateur (`user`) ou le
 * journal global (`user` = null, filtre sur l'identifiant en plus).
 */
export default function LoginHistoryModal({ user, onClose }) {
  const [filters, setFilters] = useState({ username: '', success: '', from: '', to: '' });
  const [page, setPage] = useState(0);
  const [data, setData] = useState({ content: [], totalPages: 0, totalElements: 0 });
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    setLoading(true);
    getLoginEvents({
      userId: user?.id,
      username: !user && filters.username ? filters.username : undefined,
      success: filters.success || undefined,
      from: filters.from ? filters.from + 'T00:00:00' : undefined,
      to: filters.to ? filters.to + 'T23:59:59' : undefined,
      page,
      size: PAGE_SIZE,
    }).then(setData).finally(() => setLoading(false));
  }, [user, filters, page]);

  const setFilter = field => e => { setFilters({ ...filters, [field]: e.target.value }); setPage(0); };

  return (
    <Modal title={user ? `Connexions de ${user.username}` : 'Journal de connexion'}
           width={900} onClose={onClose}>
        {user?.role === 'PUSH_AGENT' && (
          <p style={{ color: '#955d00', fontSize: '0.8rem', margin: '0 0 0.5rem' }}>
            Compte robot : historique conservé 30 jours.
          </p>
        )}

        <div style={{ display: 'flex', gap: '0.75rem', flexWrap: 'wrap', margin: '1rem 0' }}>
          {!user && (
            <div style={{ flex: '1 1 180px' }}>
              <label style={label}>Identifiant</label>
              <input style={input} value={filters.username} onChange={setFilter('username')} placeholder="contient…" />
            </div>
          )}
          <div style={{ flex: '1 1 150px' }}>
            <label style={label}>Résultat</label>
            <select style={input} value={filters.success} onChange={setFilter('success')}>
              <option value="">Tous</option>
              <option value="true">Réussies</option>
              <option value="false">Échouées</option>
            </select>
          </div>
          <div style={{ flex: '1 1 150px' }}>
            <label style={label}>Du</label>
            <input style={input} type="date" value={filters.from} onChange={setFilter('from')} />
          </div>
          <div style={{ flex: '1 1 150px' }}>
            <label style={label}>Au</label>
            <input style={input} type="date" value={filters.to} onChange={setFilter('to')} />
          </div>
        </div>

        <div style={{ overflowX: 'auto', opacity: loading ? 0.6 : 1 }}>
          <table style={{ width: '100%', minWidth: '700px', borderCollapse: 'collapse', fontSize: '0.85rem' }}>
            <thead>
              <tr style={theadRow}>
                {[...(user ? [] : ['Utilisateur']), 'Date', 'Résultat', 'IP', 'Navigateur / client'].map(h =>
                  <th key={h} style={th}>{h}</th>)}
              </tr>
            </thead>
            <tbody>
              {data.content.map(e => (
                <tr key={e.id} style={{ borderBottom: '1px solid #ececec' }}>
                  {!user && (
                    <td style={{ ...td, fontWeight: 600 }}>
                      {e.username || <span style={muted}>vide</span>}
                    </td>
                  )}
                  <td style={{ ...td, whiteSpace: 'nowrap' }}>{formatDateTime(e.loggedAt)}</td>
                  <td style={td}>
                    {e.success
                      ? <span style={badge('#e2f3e8', '#1a7f37')}>
                          Réussie{e.secondFactor ? ` · ${SECOND_FACTORS[e.secondFactor] || e.secondFactor}` : ''}
                        </span>
                      : <span style={badge('#fdecea', '#b3261e')}>{FAILURES[e.failureReason] || 'Échec'}</span>}
                  </td>
                  <td style={{ ...td, fontFamily: 'monospace', color: '#6b7280' }}>{e.ipAddress || '—'}</td>
                  <td style={{ ...td, color: '#8a8f99', fontSize: '0.78rem', maxWidth: '320px', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}
                      title={e.userAgent || ''}>
                    {e.userAgent || '—'}
                  </td>
                </tr>
              ))}
              {!loading && data.content.length === 0 && (
                <tr><td colSpan={5} style={{ ...td, textAlign: 'center', color: '#8a8f99', padding: '2rem' }}>
                  Aucune connexion journalisée
                </td></tr>
              )}
            </tbody>
          </table>
        </div>

        <Pager page={page} totalPages={data.totalPages} totalElements={data.totalElements} onPage={setPage} />
    </Modal>
  );
}
